export default __webpack_public_path__ + "static/screen_1_06-4f90ad551adbd47db5aba159af763c82.svg";